import {
	LayoutDashboard,
	Users,
	UserCircle,
	ChevronDown,
	Store,
	Wallet,
	Settings,
	ClipboardList,
	Warehouse,
	Database,
	Trophy,
	type LucideIcon,
} from 'lucide-react'

export interface MenuItem {
	id: string
	label: string
	icon?: LucideIcon
	href?: string
	children?: MenuItem[]
	badge?: string | number
	permission?: string
	supplierOnly?: boolean
}

export const menuItems: MenuItem[] = [
	{
		id: 'dashboard',
		label: '控制台',
		icon: LayoutDashboard,
		href: '/dashboard',
		permission: 'dashboard:view',
	},
	{
		id: 'customers',
		label: '客户管理',
		icon: UserCircle,
		children: [
			{ id: 'customers-list', label: '客户列表', href: '/customers', permission: 'customer:list' },
			{ id: 'customers-gifts', label: '送礼管理', href: '/customers/gifts', permission: 'customer_gift:list' },
			{ id: 'customers-service-records', label: '服务记录', href: '/customers/service-records', permission: 'service_record:list' },
			{ id: 'customers-service-statistics', label: '服务统计', href: '/customers/service-statistics', permission: 'service_record:list' },
			{ id: 'customers-department-service-statistics', label: '部门服务统计', href: '/customers/department-service-statistics', permission: 'service_record:department_statistics' },
		],
	},
	{
		id: 'users',
		label: '用户管理',
		icon: Users,
		children: [
			{ id: 'users-list', label: '用户列表', href: '/users/list', permission: 'user:list' },
			{ id: 'users-departments', label: '部门管理', href: '/users/departments', permission: 'department:list' },
			{ id: 'users-roles', label: '角色权限', href: '/users/roles', permission: 'permission:view' },
			{ id: 'users-distributors', label: '分销商管理', href: '/users/distributors', permission: 'distributor:list' },
		],
	},
	{
		id: 'supplier',
		label: '供应商管理',
		icon: Store,
		supplierOnly: true,
		children: [
			{ id: 'supplier-orders', label: '订单管理', href: '/supplier/orders' },
			{ id: 'supplier-refunds', label: '退款管理', href: '/supplier/refunds' },
			{ id: 'supplier-deposit', label: '保证金明细', href: '/supplier/deposit' },
		],
	},
	{
		id: 'admin-orders',
		label: '订单管理',
		icon: ClipboardList,
		children: [
			{ id: 'admin-orders-create', label: '创建订单', href: '/admin/orders/create', permission: 'order:create' },
			{ id: 'employee-manual-orders', label: '手动订单', href: '/employee/manual-orders', permission: 'order:manual:list' },
		],
	},
	{
		id: 'store',
		label: '仓库管理',
		icon: Warehouse,
		permission: 'store:manage',
		children: [
			{ id: 'store-gift-products', label: '礼物管理', href: '/store/gift-products', permission: 'gift_product:list' },
			{ id: 'store-materials', label: '素材库', href: '/store/materials', permission: 'material:list' },
			{ id: 'store-products', label: '商品管理', href: '/store/products', permission: 'product:list' },
		],
	},
	{
		id: 'commissions',
		label: '佣金管理',
		icon: Wallet,
		children: [
			{ id: 'employee-orders', label: '我的订单', href: '/employee/orders', permission: 'employee_order:view' },
			{ id: 'commissions-my', label: '我的佣金', href: '/commissions/my', permission: 'commission:view_my' },
			{ id: 'commissions-department', label: '部门佣金', href: '/commissions/department', permission: 'commission:view_department' },
		],
	},
	{
		id: 'data-cube',
		label: '数据魔方',
		icon: Database,
		children: [
			{ id: 'data-cube-records', label: '数据明细', href: '/data-cube/records', permission: 'data_cube:list' },
			{ id: 'data-cube-user-summary', label: '个人数据统计', href: '/data-cube/user-summary', permission: 'data_cube:list' },
			{ id: 'data-cube-user-weight', label: '员工权重', href: '/data-cube/user-weight', permission: 'data_cube:user_weight' },
			{ id: 'data-cube-department-summary', label: '部门数据统计', href: '/data-cube/department-summary', permission: 'data_cube:department_summary' },
		],
	},
	{
		id: 'performance',
		label: '业绩管理',
		icon: Trophy,
		children: [
			{ id: 'performance-employee', label: '员工业绩', href: '/performances/employee', permission: 'performance:employee' },
			{ id: 'performance-unit', label: '单位业绩', href: '/performances/unit', permission: 'performance:unit' },
			{ id: 'performance-promotion', label: '推广业绩', href: '/performances/promotion', permission: 'performance:promotion' },
			{ id: 'performance-list', label: '业绩明细', href: '/performances', permission: 'performance:list' },
			{ id: 'performance-ranking', label: '业绩排行', href: '/performances/ranking', permission: 'performance:ranking' },
			{ id: 'performance-summary', label: '业绩看板', href: '/performances/summary', permission: 'performance:summary' },
		],
	},
	{
		id: 'settings',
		label: '设置',
		icon: Settings,
		children: [
			{ id: 'settings-account', label: '账户设置', href: '/settings/account' },
			{ id: 'settings-system', label: '系统设置', href: '/settings/system', permission: 'setting:list' },
			{ id: 'settings-customer-categories', label: '客户类型', href: '/settings/customer-categories', permission: 'customer_category:list' },
			{ id: 'settings-service-types', label: '服务类型', href: '/settings/service-types', permission: 'service_type:list' },
			{ id: 'settings-promotion-bundles', label: '促销组合', href: '/settings/promotion-bundles', permission: 'promotion_bundle:list' },
			{ id: 'settings-audit-logs', label: '操作日志', href: '/settings/audit-logs', permission: 'audit:log:list' },
		],
	},
]

export { ChevronDown }
